import { CharacteristicObject } from './characteristic-object.model';

export class MultiCharacteristicObject extends CharacteristicObject {

    constructor(public name: string, public value: string[], public id: string) {
        super(name, id);
    }
    public clone(): MultiCharacteristicObject {
        return new MultiCharacteristicObject(this.name, this.value.slice(), this.id);
    }
    public equals(other: MultiCharacteristicObject): boolean {
        for (let i = 0; i < this.value.length; i++) {
            if (this.value[i] !== other.value[i]) {
                return false;
            }
        }
        return true;
    }
}
